import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  Params,
  NavigationExtras,
} from '@angular/router';

import * as $ from 'jquery';

@Component({
  selector: 'app-info-messages',
  templateUrl: './info-messages.component.html',
  styleUrls: ['./info-messages.component.scss'],
})
export class InfoMessagesComponent implements OnInit, OnChanges {
  @Input() notification: any;
  preselectedClinic: string;
  superClinicId: string;
  service: string;
  type: string;
  singleClinic: string;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params: Params) => {
      this.preselectedClinic = params.clinics;
      this.superClinicId = params.superClinicId;
      this.service = params.service;
      this.type = params.type;
      this.singleClinic = params.singleClinic;
    });
  }

  ngOnChanges() {
    this.showNotification(this.notification);
  }

  showNotification(currentNotification: any) {
    const messageBlock = $('#notification-message');

    this.notification.message = currentNotification.message;
    this.notification.type = currentNotification.type;

    messageBlock.addClass('message-' + currentNotification.type);

    setTimeout(function () {
      messageBlock.removeClass('message-' + currentNotification.type);
    }, 3000);
  }

  goToLogin() {
    this.setupUrl('/login');
  }

  goToPassword() {
    this.setupUrl('/forgot-password');
  }

  setupUrl(url) {
    const params = {
      type: this.type,
      service: this.service,
      singleClinic: this.singleClinic,
    };

    // if superclinic and superclinic + service flow, send params to next page
    if (this.superClinicId) {
      params['superClinicId'] = this.superClinicId;
    }

    // if singleclinic flow, send clinics params to next page
    if (this.singleClinic === 'true') {
      params['clinics'] = this.preselectedClinic;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: params,
    };

    this.router.navigate([url], navigationExtras);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/info-messages/info-messages.component.ts